<template>

    <div>

    
      <br/>

      <div v-if = "goog_id=='a'">
         
            <div class="alert alert-warning" role="alert">
                  You need to sign in to access this page
                </div>      
         </div>

          <div v-if = "goog_id != 'a' && $store.state.myDataDict.length==0" class="alert alert-danger" role="alert">
               <h4 class="alert-heading">You need to upload your transcript silly!</h4>
               <p>After you upload your transcript, this page will be populated!</p>
               <hr>

               <router-link :to="{ name: 'uploadtranscript', params: {  }}">
                     
                     <p class="mb-0">CLICK HERE to upload your transcript</p>
                 </router-link>
             </div>
             <div v-if = "$store.state.myDataDict.length!=0">





               <!-- On rows -->
               <table class="table table-hover">
                     <thead>
                       <tr>
                         <th scope="col">Course</th>
                         <th scope="col">Credits Earned</th>
                         <th scope="col">Grade Received</th>
                         <th scope="col">Professor Name</th>
                         <th scope="col">My Rating</th>
                         <th scope="col">Difficulty</th>
                         <th scope="col">Time</th>
                         <th scope='col'>Comments</th>
                       </tr>
                     </thead>
                     <tbody>
                       <tr v-for="(c,index) in $store.state.myDataDict" :key="index">
                         <th scope="row"><a href="javascript:void(0)"><span @click="gotoroute(c.course_id)">{{c.course_str}}</span></a></th>
                         <td>{{c.earned}}</td>
                         <td>{{c.grade_str}}</td>
                         <td>

                          <div v-if="c.prof_id">

                            <a href = "javascript:void(0)">
                              
                              <span @click="gotorouteProf(c.prof_id)"> {{c.FirstName}} {{c.LastName}}
                              </span> 
                            </a>
                          </div>

                          <div v-else>
                            <select   class="form-control" @change="changeProfessor($event,c.ID,index)">
                                <option value="" disabled selected>Select one--</option>
                              <option  v-bind:value="option.prof_id"  v-for="option in c.prof_ids"><span >{{option.FirstName}} {{option.LastName}} </span></option>
                            </select>

                  
                          </div>
                        </td>
                         <td>

                          <div class = "container">
                           <div class = "row">
                           <!-- {{c.quality}} -->
                           <span v-show="c.like_int == null" @click="changeRating(index,c.ID,1)"><i  class = "far fa-thumbs-up fa-2x"></i></span>
                           <span v-show="c.like_int == 1" @click="changeRating(index,c.ID,-1)"><i  class="fas fa-thumbs-up fa-2x" ></i></span>
                           <span v-show="c.like_int == null"  @click="changeRating(index,c.ID,0)"><i class = "far fa-thumbs-down fa-2x"></i></span>
                           <span v-show= "c.like_int == 0"  @click="changeRating(index,c.ID,-1)"><i  class="fas fa-thumbs-down fa-2x" ></i></span>
                           <div v-show="c.loading == true"class="loadersmall">Loading...</div>
                          </div>
                          </div>
                         </td>
                         <td>

                          <div v-if="!c.difficulty">

                            <div class="btn-group btn-group-sm" role="group" aria-label="Basic example">
                              <button @click="changeDifficulty(index,c.ID,1.0)" type="button" class="btn btn-secondary btn-success">Easy</button>
                              <button @click="changeDifficulty(index,c.ID,3.0)" type="button" class="btn btn-secondary btn-warning">Medium</button>
                              <button @click="changeDifficulty(index,c.ID,5.0)" type="button" class="btn btn-secondary btn-danger">Hard</button>
                            </div>
                          </div>
                          <div v-else>

                            <div class = "container">
                              <div class = "row">

                                <div class = "col-6">

                                  <button  v-if ="c.difficulty <=2.0"  :id="index" type="button" class="btn btn-success btn-default">
                                    Easy
                                  </button>
                                  <button  v-else-if ="c.difficulty <=4.0" :id="index" type="button" class="btn btn-warning btn-default" >
                                    Medium
                                  </button>
                                  <button  v-else  :id="index" type="button" class="btn btn-danger btn-default">
                                    Hard
                                  </button>
                                </div>

                                <div  class = "col">
                                  <span @click="changeDifficulty(index,c.ID,-1)">
                                  <i class="far fa-window-close fa-lg" ></i>
                                  </span>
                                    <!-- <button class="far fa-window-close fa-lg" @click="changeDifficulty(index)"> ddddd</button> -->
     
                                </div>
                                
                                
                                
                              </div>
                            </div>
                
           
                          </div>
                        </td>
                         <td>{{c.quarter}} {{c.year}}</td>

     
                         <td> 



                            <div v-if = "editedCommentIndex == index" v-on:keyup.enter="saveComment(index)">
                              <input type = "text" v-model="editedComment">
          
                            </div>
                            <div v-else @click="changeEditMode(index)">
                              <div v-if="c.comment">
                                {{c.comment}}
                              </div>
                              <div v-else>
                                Click to add comment
                              </div>
                              </div>
                          </td>
                       </tr>
                     </tbody>
                   </table>
                <!-- {{$store.state.myDataDict}} -->
               </div>

          
 
    </div>
 
 </template>
 
 <script>

//import ClickOutside from 'vue-click-outside'
    import axios from 'axios'

   import { mapState } from 'vuex'

    export default {
       name: 'Mydata',
       components: {
       },
       data() {
          return {
             title: 'mydata',

             editedComment: '',
             editedCommentIndex: -1,
             selected: ''
          }
       },
       watch: {

      },
       created() {
          this.initialize()
       },
    
       methods: {
          initialize() {
            //  this.$store.state.myDataDict = this.$store.state.myDataDict
            //  console.log('the length is', this.$store.state.myDataDict)
          }, 
          gotorouteProf(prof_id){
            this.$router.push({name:'Prof_profile',params:{id:prof_id}})

           },  
          gotoroute(course_id){
            this.$router.push({name:'Course_profile',params:{id:course_id}})

           },  

           async changeEditMode(index){
             //console.log(index)
             this.editedCommentIndex = index
             this.editedComment = this.$store.state.myDataDict[index].comment
           },
           async saveComment(index) {
            console.log(index)
            this.changeComment(index,this.$store.state.myDataDict[index].ID,this.editedComment)
            this.editedCommentIndex = -1
            this.editedComment = ''
           },


         changeRating(index,gradeID, type_int){
           console.log(gradeID + ' ' + type_int)
           var bodyFormData = new FormData();
            bodyFormData.append('goog_id', this.$store.state.goog_id);
            bodyFormData.append('grade_id', gradeID);
            bodyFormData.append('type_int', type_int)
            // this.$store.state.loading = true
            this.$store.state.myDataDict[index].loading = true;
            var vm = this
            axios({
              method: 'post',  //http://localhost:8080  https://faceclass-221a7.appspot.com
              url: 'https://faceclass-221a7.appspot.com/changerating',
              data: bodyFormData,
              config: { headers: {'Content-Type': 'multipart/form-data' }}
              })
              .then(function (response) {
                // vm.$store.state.loading = false
                vm.$store.state.myDataDict[index].loading = false;
                // vm.getMyData()

                if (type_int == -1) {
                  vm.$store.state.myDataDict[index].like_int = null;
                } else {
                vm.$store.state.myDataDict[index].like_int = type_int;
                }
                
              })
              .catch(function (response) {
                  //handle error
                  console.log(response);
              });
         },
         changeComment(index,gradeID, commentIn){
          console.log(gradeID + ' ' + commentIn)
          var bodyFormData = new FormData();
           bodyFormData.append('goog_id', this.$store.state.goog_id);
           bodyFormData.append('grade_id', gradeID);
           bodyFormData.append('comment', commentIn)
           // this.$store.state.loading = true
           this.$store.state.myDataDict[index].loading = true;
           var vm = this
           axios({
             method: 'post',  //http://localhost:8080  https://faceclass-221a7.appspot.com
             url: 'https://faceclass-221a7.appspot.com/changecomment',
             data: bodyFormData,
             config: { headers: {'Content-Type': 'multipart/form-data' }}
             })
             .then(function (response) {
               // vm.$store.state.loading = false
               vm.$store.state.myDataDict[index].loading = false;
               // vm.getMyData()
                 vm.$store.state.myDataDict[index].comment = commentIn;

               
             })
             .catch(function (response) {
                 //handle error
                 console.log(response);
             });
        },
        changeDifficulty(index, theID, difficultyIn){

          console.log("this is changing difficulty")
          console.log(difficultyIn);
          var bodyFormData = {
            'goog_id' : this.$store.state.goog_id,
            'ID':theID,
            'difficulty':difficultyIn
          }
          var vm = this
          this.$store.state.loading = true
          axios({
            method: 'post',
            
            // url: 'https://us-central1-faceclass-221a7.cloudfunctions.net/nodecruz/saveprofchange',
            url: 'https://us-central1-faceclass-221a7.cloudfunctions.net/nodecruz/changedifficulty',
            data: bodyFormData,
            config: { headers: {'Content-Type': 'application/json' }}
            })
            .then(function (response) {
              vm.$store.state.loading = false

              if(difficultyIn == -1) {
                vm.$store.state.myDataDict[index].difficulty = null
              } else {
                vm.$store.state.myDataDict[index].difficulty = difficultyIn
              }
            })
            .catch(function (response) {
 
                console.log(response);
            });

        },

        changeProfessor(event,theID,index) {
          //console.log('prof switched');
          //console.log(event.target.value);
          //var theElement = 
          const actualIndex = event.target.options.selectedIndex - 1;
          const firstName = this.$store.state.myDataDict[index].prof_ids[actualIndex].FirstName
          const lastName = this.$store.state.myDataDict[index].prof_ids[actualIndex].LastName
          //console.log(this.$store.state.goog_id)
          //console.log(theID)
          //console.log(event.target);
          var bodyFormData = {
            'goog_id' : this.$store.state.goog_id,
            'ID':theID,
            'prof_id':event.target.value
          }
          var vm = this

          axios({
            method: 'post',
            
            url: 'https://us-central1-faceclass-221a7.cloudfunctions.net/nodecruz/saveprofchange',
            data: bodyFormData,
            config: { headers: {'Content-Type': 'application/json' }}
            })
            .then(function (response) {
              vm.$store.state.loading = false
              console.log(response.data)
              vm.$store.state.myDataDict[index]['prof_id'] = event.target.value;
              vm.$store.state.myDataDict[index]['FirstName'] = firstName
              vm.$store.state.myDataDict[index]['LastName'] = lastName
            })
            .catch(function (response) {
 
                console.log(response);
            });



          

        }

       },
       computed: {
         ...mapState([
         'goog_id',
         'myDataDict'
      ])
       },
       mounted() {
       },
       directives: {
        //ClickOutside
      }
    }
 </script>
 
 <style scoped>
   .loadersmall,
.loadersmall:before,
.loadersmall:after {
  border-radius: 20%;
  width: 1.5em;
  height: 1.5em;
  -webkit-animation-fill-mode: both;
  animation-fill-mode: both;
  -webkit-animation: load7 1.8s infinite ease-in-out;
  animation: load7 1.8s infinite ease-in-out;
}
.loadersmall {
  color: #4c83b8;
  font-size: 8px;
  margin: 10px auto;
  position: relative;
  text-indent: -9999em;
  -webkit-transform: translateZ(0);
  -ms-transform: translateZ(0);
  transform: translateZ(0);
  -webkit-animation-delay: -0.16s;
  animation-delay: -0.16s;
}
.loadersmall:before,
.loadersmall:after {
  content: '';
  position: absolute;
  top: 0;
}
.loadersmall:before {
  left: -3.5em;
  -webkit-animation-delay: -0.32s;
  animation-delay: -0.32s;
}
.loadersmall:after {
  left: 3.5em;
}
@-webkit-keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}
@keyframes load7 {
  0%,
  80%,
  100% {
    box-shadow: 0 2.5em 0 -1.3em;
  }
  40% {
    box-shadow: 0 2.5em 0 0;
  }
}

 </style>